// Realistic Italian manufacturing mock data
// Structured to be easily expandable to Europe in future versions

export const currentUser = {
  id: "usr_001",
  name: "Marco Ferrari",
  company: "Ferrari Composites S.r.l.",
  userType: "professional",
  location: "Modena, IT",
  avatarInitials: "MF",
  status: "available",
  reputation: 84,
};

// Trust indicators for the platform — used on login & finder
export const networkStats = {
  producers: 1284,
  requestsMonth: 3612,
  countries: 7,
  avgMatchSeconds: 42,
  onTimeAvg: 96,
  verifiedShare: 91,
};

// Counters that make Home feel "alive"
export const activityCounters = {
  newRequests: 5,      // new opportunities matching your profile
  newReplies: 3,       // new replies on your requests
  newMessages: 2,
  newProfiles: 4,      // new compatible profiles
  newOpportunities: 7,
};

// User categories — inclusive, not rigid
export const userTypes = [
  "individual", "maker", "student", "freelancer",
  "startup", "professional", "workshop", "company",
];

// Detailed match breakdown: each reason contributes to overall compatibility
// Reasons expose the "why" — this is the transparency layer
const buildReasons = (skills, materials, capacity, location, certifications) => ([
  { label: "Skills", score: skills },
  { label: "Materials", score: materials },
  { label: "Capacity", score: capacity },
  { label: "Location", score: location },
  { label: "Certifications", score: certifications },
]);

export const producers = [
  {
    id: "prd_001",
    name: "Officina Meccanica Bertolini",
    userType: "workshop",
    positioning: "Tornitura CNC di alta precisione per aeronautica e racing",
    location: "Brescia, IT",
    distanceKm: 42,
    availability: "available",
    compatibility: 94,
    matchReasons: buildReasons(98, 92, 89, 96, 95),
    reputation: 92,
    verified: true,
    responseRate: 98,
    responseTimeH: 3,
    onTimeRate: 97,
    yearsActive: 12,
    projectsCompleted: 340,
    profileCompleteness: 96,
    rateFrom: 85,
    leadTimeDays: 14,
    skills: ["Tornitura CNC 5 assi", "Fresatura", "Rettifica", "Prototipazione rapida"],
    materials: ["Alluminio 7075", "Titanio Grado 5", "Acciaio Inox 316L", "Ottone", "PEEK"],
    machines: ["DMG Mori NLX 2500", "Mazak Integrex i-400", "Studer S31", "Hermle C42U"],
    certifications: ["ISO 9001:2015", "EN 9100 Aerospace", "IATF 16949"],
    portfolio: [
      "https://images.unsplash.com/photo-1666618090858-fbcee636bd3e?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
      "https://images.unsplash.com/photo-1711418235334-8895331a6cf9?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
      "https://images.unsplash.com/photo-1519461352530-de7c9bfeeb84?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    ],
    links: [{ label: "Sito web", url: "https://bertolini-cnc.example" }],
    tags: ["CNC", "Precision", "Aerospace"],
  },
  {
    id: "prd_002",
    name: "Ferrari Composites",
    userType: "workshop",
    positioning: "Fibra di carbonio strutturale per automotive e ciclismo",
    location: "Modena, IT",
    distanceKm: 8,
    availability: "limited",
    compatibility: 89,
    matchReasons: buildReasons(94, 96, 71, 99, 88),
    reputation: 84,
    verified: true,
    responseRate: 92,
    responseTimeH: 6,
    onTimeRate: 94,
    yearsActive: 9,
    projectsCompleted: 187,
    profileCompleteness: 92,
    rateFrom: 140,
    leadTimeDays: 30,
    skills: ["Laminazione manuale", "Prepreg autoclave", "RTM", "Verniciatura tecnica"],
    materials: ["Carbon T700", "Carbon T800", "Kevlar", "Fibra di vetro", "Nomex honeycomb"],
    machines: ["Autoclave Scholz 3000x1500", "CNC 5 assi Belotti", "Forni Heraeus"],
    certifications: ["ISO 9001:2015", "UNI EN 9100"],
    portfolio: [
      "https://images.unsplash.com/photo-1675176785803-bffbbb0cd2f4?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
      "https://images.unsplash.com/photo-1517420704952-d9f39e95b43e?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
      "https://images.unsplash.com/photo-1552664730-d307ca884978?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    ],
    links: [{ label: "Portfolio", url: "https://ferrari-composites.example" }],
    tags: ["Carbon", "Automotive", "Racing"],
  },
  {
    id: "prd_003",
    name: "3DLab Milano",
    userType: "startup",
    positioning: "Stampa 3D industriale: SLS, SLA e MJF per prototipi e serie",
    location: "Milano, IT",
    distanceKm: 187,
    availability: "available",
    compatibility: 82,
    matchReasons: buildReasons(88, 84, 92, 62, 78),
    reputation: 78,
    verified: true,
    responseRate: 95,
    responseTimeH: 2,
    onTimeRate: 91,
    yearsActive: 7,
    projectsCompleted: 512,
    profileCompleteness: 88,
    rateFrom: 45,
    leadTimeDays: 5,
    skills: ["SLS", "SLA", "MJF", "FDM industriale", "Post-processing"],
    materials: ["Nylon PA12", "TPU 88A", "Resina Tough", "PEEK", "Alluminio (DMLS)"],
    machines: ["HP MJF 5210", "EOS P396", "Formlabs Form 3L", "EOS M290"],
    certifications: ["ISO 9001:2015"],
    portfolio: [
      "https://images.unsplash.com/photo-1631545308456-3d9dfc3e08b6?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
      "https://images.unsplash.com/photo-1611117775350-ac3950990985?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
      "https://images.unsplash.com/photo-1581092918484-8313ec5f0f8f?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    ],
    links: [{ label: "Sito web", url: "https://3dlab.example" }],
    tags: ["3D Printing", "Prototyping", "SLS"],
  },
  {
    id: "prd_004",
    name: "LaserTech Brescia",
    userType: "workshop",
    positioning: "Taglio laser fibra e piegatura lamiera fino a 25mm",
    location: "Brescia, IT",
    distanceKm: 45,
    availability: "available",
    compatibility: 78,
    matchReasons: buildReasons(82, 80, 88, 74, 66),
    reputation: 71,
    verified: true,
    responseRate: 89,
    responseTimeH: 5,
    onTimeRate: 88,
    yearsActive: 15,
    projectsCompleted: 890,
    profileCompleteness: 82,
    rateFrom: 30,
    leadTimeDays: 7,
    skills: ["Taglio laser fibra", "Piegatura CNC", "Saldatura TIG/MIG", "Verniciatura"],
    materials: ["Acciaio S235", "Inox AISI 304/316", "Alluminio", "Corten"],
    machines: ["Bystronic ByStar Fiber 10kW", "Trumpf TruBend 5170", "Cabina verniciatura Wagner"],
    certifications: ["ISO 9001:2015", "EN 1090-2 EXC3"],
    portfolio: [
      "https://images.unsplash.com/photo-1738162837451-2041c1418f54?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
      "https://images.unsplash.com/photo-1504222490345-c075b6008014?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
      "https://images.unsplash.com/photo-1565608087341-404b25492fee?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    ],
    links: [],
    tags: ["Laser", "Sheet Metal", "Welding"],
  },
  {
    id: "prd_005",
    name: "Giulia Marconi",
    userType: "maker",
    positioning: "Maker e designer indipendente — piccole serie in pelle e legno",
    location: "Bologna, IT",
    distanceKm: 45,
    availability: "available",
    compatibility: 71,
    matchReasons: buildReasons(72, 78, 68, 76, 55),
    reputation: 58,
    verified: false,
    responseRate: 78,
    responseTimeH: 12,
    onTimeRate: 85,
    yearsActive: 3,
    projectsCompleted: 24,
    profileCompleteness: 68,
    rateFrom: 40,
    leadTimeDays: 20,
    skills: ["Cucitura manuale", "Falegnameria leggera", "Prototipazione"],
    materials: ["Pelle vegetale", "Legno di rovere", "Ottone"],
    machines: ["Cucitrice Adler", "Fresa da banco Proxxon"],
    certifications: [],
    portfolio: [
      "https://images.unsplash.com/photo-1449505078894-c17b0d1cc6f5?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
      "https://images.unsplash.com/photo-1520639888713-7851133b1ed0?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    ],
    links: [],
    tags: ["Maker", "Leather", "Wood"],
  },
  {
    id: "prd_006",
    name: "Andrea Romano",
    userType: "freelancer",
    positioning: "Freelance engineer — supporto CAD, DfM e post-processing SLS",
    location: "Torino, IT",
    distanceKm: 96,
    availability: "available",
    compatibility: 76,
    matchReasons: buildReasons(84, 68, 82, 78, 68),
    reputation: 66,
    verified: true,
    responseRate: 90,
    responseTimeH: 4,
    onTimeRate: 89,
    yearsActive: 5,
    projectsCompleted: 61,
    profileCompleteness: 84,
    rateFrom: 55,
    leadTimeDays: 3,
    skills: ["CAD 3D", "DfM", "Simulazione FEM", "Post-processing"],
    materials: ["Nylon PA12", "PEEK", "TPU"],
    machines: ["Prusa i3 MK4", "Formlabs Form 3"],
    certifications: [],
    portfolio: [
      "https://images.unsplash.com/photo-1611117775350-ac3950990985?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    ],
    links: [],
    tags: ["Freelance", "CAD", "3D Printing"],
  },
];

export const requests = [
  {
    id: "REQ-2401",
    title: "Telaio in fibra di carbonio per bici da corsa",
    titleEn: "Carbon fiber road bike frame",
    client: "VeloTech Milano",
    clientType: "startup",
    category: "Composites",
    material: "Carbon T800 prepreg",
    quantity: 25,
    budget: "€ 18.000 – 24.000",
    budgetNum: 22000,
    deadline: "12 settimane",
    location: "Milano, IT",
    distanceKm: 187,
    compatibility: 96,
    matchReasons: buildReasons(98, 96, 92, 88, 94),
    reputation: 82,
    postedAt: "2h",
    postedAtMinutes: 120,
    tags: ["Carbon", "Autoclave", "Racing"],
    urgent: true,
    isNew: true,
  },
  {
    id: "REQ-2400",
    title: "Componenti alluminio 7075 per drone industriale",
    titleEn: "Aluminum 7075 parts for industrial drone",
    client: "SkyRobot Torino",
    clientType: "company",
    category: "CNC Machining",
    material: "Alluminio 7075-T6",
    quantity: 500,
    budget: "€ 8.500",
    budgetNum: 8500,
    deadline: "6 settimane",
    location: "Torino, IT",
    distanceKm: 96,
    compatibility: 91,
    matchReasons: buildReasons(94, 92, 88, 82, 96),
    reputation: 88,
    postedAt: "5h",
    postedAtMinutes: 300,
    tags: ["CNC", "Aerospace"],
    isNew: true,
  },
  {
    id: "REQ-2399",
    title: "Prototipi in SLS per dispositivo medicale",
    titleEn: "SLS prototypes for medical device",
    client: "MediPro Bologna",
    clientType: "startup",
    category: "3D Printing",
    material: "Nylon PA12 biocompatibile",
    quantity: 12,
    budget: "€ 2.400",
    budgetNum: 2400,
    deadline: "10 giorni",
    location: "Bologna, IT",
    distanceKm: 45,
    compatibility: 87,
    matchReasons: buildReasons(90, 88, 92, 78, 84),
    reputation: 74,
    postedAt: "1g",
    postedAtMinutes: 1440,
    tags: ["SLS", "Medical"],
  },
  {
    id: "REQ-2398",
    title: "Lamiera piegata in inox per arredo urbano",
    titleEn: "Bent stainless steel for urban furniture",
    client: "Comune di Reggio Emilia",
    clientType: "company",
    category: "Sheet Metal",
    material: "Inox AISI 316L 4mm",
    quantity: 120,
    budget: "€ 32.000",
    budgetNum: 32000,
    deadline: "8 settimane",
    location: "Reggio Emilia, IT",
    distanceKm: 28,
    compatibility: 84,
    matchReasons: buildReasons(88, 82, 84, 92, 74),
    reputation: 91,
    postedAt: "1g",
    postedAtMinutes: 1440,
    tags: ["Laser", "Sheet Metal"],
  },
  {
    id: "REQ-2397",
    title: "Portachiavi in ottone per una piccola boutique",
    titleEn: "Brass keychains for a small boutique",
    client: "Sofia Neri",
    clientType: "individual",
    category: "CNC Machining",
    material: "Ottone",
    quantity: 40,
    budget: "€ 380",
    budgetNum: 380,
    deadline: "3 settimane",
    location: "Firenze, IT",
    distanceKm: 152,
    compatibility: 74,
    matchReasons: buildReasons(78, 76, 82, 68, 66),
    reputation: 42,
    postedAt: "2g",
    postedAtMinutes: 2880,
    tags: ["Small run", "Brass"],
  },
  {
    id: "REQ-2396",
    title: "Stampo iniezione plastica per componente automotive",
    titleEn: "Injection mold for automotive component",
    client: "AutoParts Modena",
    clientType: "company",
    category: "Molds",
    material: "Acciaio 1.2344 (H13)",
    quantity: 1,
    budget: "€ 45.000 – 60.000",
    budgetNum: 52500,
    deadline: "16 settimane",
    location: "Modena, IT",
    distanceKm: 8,
    compatibility: 69,
    matchReasons: buildReasons(72, 70, 60, 88, 74),
    reputation: 86,
    postedAt: "3g",
    postedAtMinutes: 4320,
    tags: ["Molds", "Automotive"],
  },
];

// The "active" search on the Finder dashboard
export const activeSearch = {
  id: "SRC-0042",
  query: "Telaio bici in carbonio · 25 pezzi · consegna 12 settimane",
  queryEn: "Carbon bike frame · 25 pcs · delivery 12 weeks",
  material: "Carbon T800 prepreg",
  quantity: 25,
  tolerance: "±0.1 mm",
  region: "Nord Italia",
  startedAgo: "8 min",
  liveMatches: 12,
};

export const recentQueries = [
  { id: "q1", label: "Alluminio 7075 · CNC · 500 pz", labelEn: "Aluminum 7075 · CNC · 500 pcs", when: "Ieri", matches: 18 },
  { id: "q2", label: "Nylon PA12 · SLS · 12 prototipi", labelEn: "Nylon PA12 · SLS · 12 prototypes", when: "2g fa", matches: 9 },
  { id: "q3", label: "Inox 316L 4mm · piegatura · 120 pz", labelEn: "316L 4mm · bending · 120 pcs", when: "1 sett.", matches: 22 },
];

// Recent replies to my requests — feeds the "New replies" section on Home
export const myReplies = [
  {
    id: "rep_1",
    onRequest: "REQ-2401",
    from: "Officina Bertolini",
    reputation: 92,
    userType: "workshop",
    excerpt: "Possiamo fare le sezioni CNC del movimento centrale, tolleranza ±0.05mm.",
    excerptEn: "We can produce the CNC bottom bracket sections, ±0.05mm tolerance.",
    when: "12 min",
    unread: true,
  },
  {
    id: "rep_2",
    onRequest: "REQ-2401",
    from: "Ferrari Composites",
    reputation: 84,
    userType: "workshop",
    excerpt: "Autoclave disponibile per la finestra richiesta. Ti mando lay-up proposto.",
    excerptEn: "Autoclave available in the requested window. Sending lay-up proposal.",
    when: "38 min",
    unread: true,
  },
  {
    id: "rep_3",
    onRequest: "REQ-2400",
    from: "Andrea Romano",
    reputation: 66,
    userType: "freelancer",
    excerpt: "Posso occuparmi del DfM e post-processing. Disponibile lunedì.",
    excerptEn: "I can handle DfM and post-processing. Available Monday.",
    when: "1h",
    unread: false,
  },
];

export const conversations = [
  {
    id: "conv_1",
    with: "Officina Bertolini",
    lastMessage: "Perfetto, posso confermare la consegna per venerdì.",
    lastMessageEn: "Perfect, I can confirm delivery for Friday.",
    time: "12:24",
    unread: 2,
    online: true,
    initials: "OB",
  },
  {
    id: "conv_2",
    with: "3DLab Milano",
    lastMessage: "Ti mando il preventivo aggiornato entro sera.",
    lastMessageEn: "I'll send the updated quote by evening.",
    time: "10:02",
    unread: 0,
    online: true,
    initials: "3D",
  },
  {
    id: "conv_3",
    with: "LaserTech Brescia",
    lastMessage: "Le tolleranze sono ok, procedo con il taglio.",
    lastMessageEn: "Tolerances are ok, proceeding with cutting.",
    time: "Ieri",
    unread: 0,
    online: false,
    initials: "LT",
  },
  {
    id: "conv_4",
    with: "Andrea Romano",
    lastMessage: "Il try-out è programmato per lunedì mattina.",
    lastMessageEn: "Try-out scheduled for Monday morning.",
    time: "Lun",
    unread: 1,
    online: false,
    initials: "AR",
  },
];

export const chatMessages = [
  { id: 1, from: "them", text: "Ciao Marco, ho ricevuto il file STEP.", textEn: "Hi Marco, I received the STEP file.", time: "12:10" },
  { id: 2, from: "them", text: "Le tolleranze indicate sono fattibili con la nostra 5 assi.", textEn: "The specified tolerances are feasible on our 5-axis.", time: "12:11" },
  { id: 3, from: "me", text: "Ottimo. Che tempo di consegna riesci a fare?", textEn: "Great. What lead time can you offer?", time: "12:18" },
  { id: 4, from: "them", text: "12 giorni lavorativi dalla conferma.", textEn: "12 working days from confirmation.", time: "12:22" },
  { id: 5, from: "them", text: "Perfetto, posso confermare la consegna per venerdì.", textEn: "Perfect, I can confirm delivery for Friday.", time: "12:24" },
];

export const notifications = [
  { id: "n1", type: "match", title: "3 nuove richieste compatibili con te", titleEn: "3 new requests compatible with you", time: "10 min fa", unread: true },
  { id: "n2", type: "proposal", title: "Nuova proposta da Officina Bertolini", titleEn: "New proposal from Officina Bertolini", time: "1h fa", unread: true },
  { id: "n3", type: "message", title: "3DLab Milano ti ha scritto", titleEn: "3DLab Milano sent you a message", time: "3h fa", unread: false },
  { id: "n4", type: "system", title: "La tua disponibilità scade fra 2 giorni", titleEn: "Your availability expires in 2 days", time: "Ieri", unread: false },
  { id: "n5", type: "match", title: "1 utente compatibile aggiunto al network", titleEn: "1 compatible user joined the network", time: "2g fa", unread: false },
];

export const communityContent = {
  questions: [
    { id: "q1", title: "Qual è la tolleranza minima ottenibile in tornitura CNC su titanio Grado 5?", titleEn: "What's the tightest tolerance achievable turning Ti Grade 5?", author: "Luca R.", answers: 8, views: 342, tag: "CNC" },
    { id: "q2", title: "Prepreg autoclave vs infusione RTM: quando conviene passare?", titleEn: "Prepreg autoclave vs RTM infusion: when to switch?", author: "Silvia M.", answers: 12, views: 1204, tag: "Composites" },
    { id: "q3", title: "Post-processing su parti SLS PA12: quali finiture per uso finale?", titleEn: "SLS PA12 post-processing: which finishes for end-use?", author: "Andrea B.", answers: 5, views: 289, tag: "3D Printing" },
  ],
  tutorials: [
    { id: "t1", title: "Progettare per la stampa 3D: 10 regole DfAM", titleEn: "Designing for 3D printing: 10 DfAM rules", author: "3DLab Milano", answers: 0, views: 2100, tag: "DfAM" },
    { id: "t2", title: "Guida al taglio laser fibra su inox spessi", titleEn: "Fiber laser cutting on thick stainless: guide", author: "LaserTech", answers: 0, views: 890, tag: "Laser" },
  ],
  experiences: [
    { id: "e1", title: "Come abbiamo ridotto del 40% i tempi di setup su Mazak Integrex", titleEn: "How we cut setup times by 40% on Mazak Integrex", author: "Officina Bertolini", answers: 4, views: 512, tag: "CNC" },
  ],
  events: [
    { id: "ev1", title: "MECSPE 2026 – Fiera di Bologna", titleEn: "MECSPE 2026 – Bologna Fair", author: "Bologna", answers: 0, views: 0, tag: "5–7 Marzo 2026" },
    { id: "ev2", title: "Additive Italy Summit – Milano", titleEn: "Additive Italy Summit – Milan", author: "Milano", answers: 0, views: 0, tag: "22 Aprile 2026" },
  ],
  topAnswers: [
    { id: "ta1", questionTitle: "Tolleranza minima su titanio Gr.5 in CNC?", questionTitleEn: "Tightest tolerance on Ti Gr.5 in CNC?", answerExcerpt: "Con macchina rigida e utensile giusto, ±0.005 mm è raggiungibile. Il segreto è il raffreddamento.", answerExcerptEn: "With a rigid machine and proper tooling, ±0.005 mm is achievable. The secret is cooling.", author: "Officina Bertolini", authorReputation: 92, votes: 24, tag: "CNC" },
    { id: "ta2", questionTitle: "Prepreg vs RTM — quale scegliere?", questionTitleEn: "Prepreg vs RTM — which one?", answerExcerpt: "Per serie <50 pezzi con qualità aerospaziale, prepreg autoclave. Sopra le 200 pz, valuta RTM.", answerExcerptEn: "For runs under 50 with aerospace quality, prepreg autoclave. Above 200 pcs, consider RTM.", author: "Ferrari Composites", authorReputation: 84, votes: 18, tag: "Composites" },
    { id: "ta3", questionTitle: "Post-processing SLS per uso finale?", questionTitleEn: "SLS post-processing for end-use?", answerExcerpt: "Vapor smoothing + tintura ad immersione. Se serve resistenza UV, aggiungi un primer protettivo.", answerExcerptEn: "Vapor smoothing + dip dyeing. If UV resistance is needed, add a protective primer.", author: "3DLab Milano", authorReputation: 78, votes: 11, tag: "3D Printing" },
    { id: "ta4", questionTitle: "Sbavatura post-taglio laser su inox?", questionTitleEn: "Post-laser deburring on stainless?", answerExcerpt: "Passata a spazzola con nastro abrasivo grana 240, poi finitura Scotch-Brite. Rapido e ripetibile.", answerExcerptEn: "Brush pass with 240-grit belt, then Scotch-Brite finish. Fast and repeatable.", author: "LaserTech Brescia", authorReputation: 71, votes: 7, tag: "Laser" },
    { id: "ta5", questionTitle: "Feature CAD per iniezione?", questionTitleEn: "CAD features for injection molding?", answerExcerpt: "Sformo min. 1°, raggi ovunque possibile, spessori uniformi. Il resto lo sistemi con la simulazione riempimento.", answerExcerptEn: "Min. 1° draft, radii wherever possible, uniform walls. The rest is refined by fill simulation.", author: "Andrea Romano", authorReputation: 66, votes: 5, tag: "DfM" },
  ],
};

export const categories = [
  "CNC Machining", "Composites", "3D Printing", "Sheet Metal",
  "Molds", "Footwear", "Woodworking", "Electronics", "Casting", "Sewing",
];

export const materials = [
  "Alluminio 7075", "Titanio Grado 5", "Acciaio Inox 316L", "Carbon T800",
  "Nylon PA12", "PEEK", "Kevlar", "Pelle bovina", "Ottone", "S235",
];

export const quickMaterials = [
  "Alluminio 7075", "Carbon T800", "Inox 316L", "Nylon PA12", "Titanio Gr.5",
];

export const aiImprovedText = {
  it: "Richiesta di produzione: telaio strutturale in fibra di carbonio (Carbon T800 prepreg) per bicicletta da corsa performance. Laminazione in autoclave a 6 bar / 130°C, orientazione fibre secondo file di stratifica allegato. Tolleranza dimensionale generale ±0,2 mm; tolleranza su interfacce meccaniche (movimento centrale, forcellini, cannotto sterzo) ±0,05 mm. Peso target 890 g (±3%). Finitura: verniciatura opaca UV-resistente su primer strutturale. Certificazioni richieste: ISO 9001 e tracciabilità completa dei materiali. Test di qualifica: prova a fatica EN 14781, ispezione ultrasuoni C-scan al 100% dei telai. Documentazione: rapporto FAI, certificato di conformità e report di prova.",
  en: "Production request: structural carbon fiber frame (Carbon T800 prepreg) for high-performance road bicycle. Autoclave curing at 6 bar / 130°C, fiber orientation as per attached lay-up file. General dimensional tolerance ±0.2 mm; mechanical interfaces (bottom bracket, dropouts, head tube) ±0.05 mm. Target weight 890 g (±3%). Finish: UV-resistant matte paint on structural primer. Required certifications: ISO 9001 and full material traceability. Qualification testing: EN 14781 fatigue test, 100% C-scan ultrasonic inspection. Documentation: FAI report, certificate of conformity and test report.",
};
